import { configureStore } from '@reduxjs/toolkit'
import { logger } from './../midlleWare/loggerWare';
import printSlice from '../redux/printSlice';
import calculateSlice  from '../redux/calcFabricSlice';
import authSlice from '../redux/authSlice';
import { socketMiddleware } from '../midlleWare/socketMiddleware';
import socketSlice from '../redux/socketSlice';
import imageSlice from '../redux/imageSlice';
import fabricSlice from './../redux/fabricSlice';
import statusSlice from '../redux/statusSlice';
import employeeSlice from '../redux/employeeSlice';
import statusFileSlice from '../redux/statusFileSlice';
import storageSlice from '../redux/storageSlice';
import storageFileSlice from '../redux/storageFileSlice';
import searchSlice from '../redux/searchSlice';
import smsSlice from '../redux/smsSlice';
import hpSlice from '../redux/hpSlice';
import falsePrintSlice from '../redux/falsePrint';

const savedUser = (() => {
  try {
    const userString = localStorage.getItem("user");
    return userString ? JSON.parse(userString) : null;
  } catch {
    return null;
  }
})();

export const store = configureStore({
  preloadedState: {
    authFile: { user: savedUser, users: [], rool: null, token: null, loading: false, status: null },
  },
  reducer: {
   orderFile:statusFileSlice,
   printFile:printSlice,
   falseFile:falsePrintSlice,
   hpFile:hpSlice,
   calcFile:calculateSlice,
   authFile:authSlice,
   socket: socketSlice,
   imageFile:imageSlice,
   fabric:fabricSlice,
   status:statusSlice,
   employee:employeeSlice,
   storage:storageSlice,
   storageFile:storageFileSlice,
   search:searchSlice,
   sms:smsSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger, socketMiddleware),
});